export const formGroup = {
  samsatId: { value: "", mandatory: true },
  samsatName: { value: "", mandatory: true },
  listCabang: { value: [], mandatory: true },
};
